import React, { Suspense, lazy } from "react";
import "../assets/css/common/style.css";
import { Routes, Route } from "react-router-dom";
import NotFound from "../components/utils/notFound";
import CareersRegister from "../components/registration";
import RegisterUpdateProfile from "../components/registration/RegistrationUpdateProfile"
import OtpVerifyScreen from "../components/registration/RegistrationOtpVerify"
import RegisterCompleteProfile from "../components/registration/RegistrationCompleteProfile";
import OneClickLogin from "../components/common/OneClickLogin";

const RegistrationRoutes = () => {
  const ROUTES = [
    { path: "/user/register", exact: true, element: <CareersRegister /> },
    { path: "/user/complete-profile", exact: true, element: <RegisterCompleteProfile /> },
    { path: "/user/otp-verify", exact: true, element: <CareersRegister /> },
    { path: "/user/login", exact: true, element: <CareersRegister /> },
    { path: "/user/login/otp-verify", exact: true, element: <OtpVerifyScreen /> },
    { path: "/user/update-profile", exact: true, element: <RegisterUpdateProfile /> },
    { path: "/check-updates", exact: true, element: <OneClickLogin/>},
    { path: "*", exact: false, element: <NotFound /> },
  ];
  return (
    <>
      <Routes>
        {ROUTES.map((obj, index) => {
          return (
            <Route
              key={index}
              path={obj.path}
              exact={obj.exact}
              element={obj.element}
            />
          );
        })}
      </Routes>
    </>
  );
};
export default RegistrationRoutes;
